import { z } from "zod";
import { MAX_INVITATIONS_PER_REQUEST } from "../../constants/invitation.constants.js";
import { emailSchema } from "../common/email.js";
import { CommunityRole } from "../enum.js";

export const invitationEntrySchema = z.object({
	email: emailSchema,
	first_name: z.string().trim().max(100).optional(),
	last_name: z.string().trim().max(100).optional(),
	role: z.enum(CommunityRole).default(CommunityRole.MEMBER),
	group_ids: z.array(z.uuid()).optional(),
	group_names: z.array(z.string().trim().min(1).max(100)).optional(),
	title: z.string().trim().max(150).optional(),
	organization: z.string().trim().max(150).optional(),
	school: z.string().trim().max(150).optional(),
	degree: z.string().trim().max(150).optional(),
	field: z.string().trim().max(150).optional(),
	city: z.string().trim().max(150).optional(),
	country: z.string().trim().max(150).optional(),
});

export type InvitationEntry = z.infer<typeof invitationEntrySchema>;

export const sendInvitationsSchema = z.object({
	invitations: z
		.array(invitationEntrySchema)
		.min(1, { message: "At least one invitation is required" })
		.max(MAX_INVITATIONS_PER_REQUEST, { message: `Maximum ${MAX_INVITATIONS_PER_REQUEST} invitations per request` }),
	message: z.string().max(500, { message: "Message must be 500 characters or less" }).optional(),
	create_missing_groups: z.boolean().default(false).optional(),
});

export type SendInvitationsPayload = z.infer<typeof sendInvitationsSchema>;

export interface SendInvitationsResult {
	sent: number;
	skipped: { email: string; reason: string }[];
	addedToExistingMembers: { email: string; group_ids: string[] }[];
	provisioned: number;
	addedAsApproved: number;
	queued: number;
	createdGroups: { id: string; name: string }[];
	unknownGroups: string[];
}
